import { Col, Row, Card, Progress, Typography } from "antd";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
const { Text } = Typography;

const CardsPercentageJob = ({ job, type, action }) => {
	const [percentagePrevious, setPercentagePrevious] = useState(0);
	const [percentageAfter, setPercentageAfter] = useState(0);
	const [percentagePoured, setPercentagePoured] = useState(0);

	useEffect(() => {
		callGetJob();
	}, [job]);

	const callGetJob = async () => {
		let percentagePrevious = 0;
		let percentageAfter = 0;
		let percentagePoured = 0;

		if (
			job.previousWorkLayoutUrl !== undefined &&
			job.previousWorkLayoutUrl !== null &&
			job.previousWorkLayoutUrl !== ""
		)
			percentagePrevious += 25;
		if (
			job.previousWorkSignatureUrl !== undefined &&
			job.previousWorkSignatureUrl !== null &&
			job.previousWorkSignatureUrl !== ""
		)
			percentagePrevious += 25;
		if (
			job.previousWorkTrucksPerHour !== undefined &&
			job.previousWorkTrucksPerHour !== null &&
			job.previousWorkTrucksPerHour !== ""
		)
			percentagePrevious += 25;
		if (
			job.previousWorkLaboratory !== undefined &&
			job.previousWorkLaboratory !== null &&
			job.previousWorkLaboratory !== ""
		)
			percentagePrevious += 25;
		setPercentagePrevious(percentagePrevious);

		if (
			job.afterWorkControlJointSpicingUrl !== undefined &&
			job.afterWorkControlJointSpicingUrl !== null &&
			job.afterWorkControlJointSpicingUrl !== ""
		)
			percentageAfter += 25;
		if (
			job.afterWorkCuringOfElementUrl !== undefined &&
			job.afterWorkCuringOfElementUrl !== null &&
			job.afterWorkCuringOfElementUrl !== ""
		)
			percentageAfter += 25;
		if (
			job.afterWorkCylindersUrl !== undefined &&
			job.afterWorkCylindersUrl !== null &&
			job.afterWorkCylindersUrl !== ""
		)
			percentageAfter += 25;
		if (
			job.afterWorkRemovedFromForm !== undefined &&
			job.afterWorkRemovedFromForm !== null &&
			job.afterWorkRemovedFromForm !== ""
		)
			percentageAfter += 25;
		setPercentageAfter(percentageAfter);

		job.loads.map((load) => {
			if (
				load.plantSlumpUrl !== undefined &&
				load.plantSlumpUrl !== null &&
				load.plantSlumpUrl !== ""
			)
				percentagePoured += 16.66;
			if (
				load.plantTemperatureUrl !== undefined &&
				load.plantTemperatureUrl !== null &&
				load.plantTemperatureUrl !== ""
			)
				percentagePoured += 16.66;
			if (
				load.jobSiteSlumpUrl !== undefined &&
				load.jobSiteSlumpUrl !== null &&
				load.jobSiteSlumpUrl !== ""
			)
				percentagePoured += 16.66;
			if (
				load.jobSiteTemperatureUrl !== undefined &&
				load.jobSiteTemperatureUrl !== null &&
				load.jobSiteTemperatureUrl !== ""
			)
				percentagePoured += 16.66;
			if (
				load.jobSiteDrumRotation !== undefined &&
				load.jobSiteDrumRotation !== null &&
				load.jobSiteDrumRotation !== ""
			)
				percentagePoured += 16.66;
			if (
				load.jobSiteWaterAdded !== undefined &&
				load.jobSiteWaterAdded !== null &&
				load.jobSiteWaterAdded !== ""
			)
				percentagePoured += 16.66;
		});

		if (job.loads.length > 0) {
			setPercentagePoured(Math.floor(percentagePoured / job.loads.length));
		} else {
			setPercentagePoured(percentagePoured);
		}
	};

	return (
		<Row gutter={16}>
			{(localStorage.getItem("pouredRole") === "Admin" ||
				localStorage.getItem("pouredRole") === "Seller") && (
				<Col span={8}>
					<Card
						title="Previous Work"
						variant="borderless"
						onClick={() => action("previouswork")}
						style={{
							backgroundColor: type === "previouswork" ? "#c1cbdb" : "#ffffff",
							cursor: "pointer",
						}}
					>
						<Progress percent={percentagePrevious} status="active" />
						<p
							style={{
								color: percentagePrevious === 100 ? "#289d3aff" : "#a81c1cff",
							}}
						>
							{percentagePrevious < 100 ? "Incompleted" : "Completed"}
						</p>
					</Card>
				</Col>
			)}
			{(localStorage.getItem("pouredRole") === "Admin" ||
				localStorage.getItem("pouredRole") === "QC") && (
				<Col span={8}>
					<Card
						title="Poured"
						variant="borderless"
						onClick={() => action("poured")}
						style={{
							backgroundColor: type === "poured" ? "#c1cbdb" : "#ffffff",
							cursor: "pointer",
						}}
					>
						<Progress percent={percentagePoured} status="active" />
						<Text
							strong
							style={{
								color: percentagePoured === 100 ? "#289d3aff" : "#a81c1cff",
							}}
						>
							{percentagePoured < 100 ? "Incompleted" : "Completed"}
						</Text>
					</Card>
				</Col>
			)}
			{(localStorage.getItem("pouredRole") === "Admin" ||
				localStorage.getItem("pouredRole") === "QC") && (
				<Col span={8}>
					<Card
						title="After Work"
						variant="borderless"
						onClick={() => action("afterwork")}
						style={{
							backgroundColor: type === "afterwork" ? "#c1cbdb" : "#ffffff",
							cursor: "pointer",
						}}
					>
						<Progress percent={percentageAfter} status="active" />
						<Text
							strong
							style={{
								color: percentageAfter === 100 ? "#289d3aff" : "#a81c1cff",
							}}
						>
							{percentageAfter < 100 ? "Incompleted" : "Completed"}
						</Text>
					</Card>
				</Col>
			)}
		</Row>
	);
};

export default CardsPercentageJob;
